/**
 * 操作手册链接
 */
export const MANUAL_LINK = {
  // 默认
  base: 'https://docs.qq.com/doc/DRGxRUGZsY3ZMZUNY?state=weworklogin&nlc=1',
  // 首页
  home: 'https://docs.qq.com/doc/DSmhCU1N0UW1XSEtw',
  // 账户
  account: 'https://docs.qq.com/doc/DSnJrQ3lNUk52dnRU',
  // 报表
  report: 'https://docs.qq.com/doc/DSm5uV294ZWFYWW9a',
  // 财务
  finance: 'https://docs.qq.com/doc/DSlNCeUZsQ2VXS0lI',
  // 工具
  manage_toolbox: 'https://docs.qq.com/doc/DSnh4Q0tJa1JUc2p4',
  // 管理
  manage: 'https://docs.qq.com/doc/DSmdTUmVBRURLQ0xR',
  // 下载
  download: 'https://docs.qq.com/doc/DSmd5T1J1UlJaWEZq',
  registration: 'https://agency-static-1258344696.file.myqcloud.com/fe/help/销售运营融合系统-开户管理操作指引.pdf',
  'sale-manage': 'https://agency-static-1258344696.file.myqcloud.com/fe/help/服务商销售管理系统操作手册V2.1.pdf',
};

/**
 * 模板链接
 */
export const TEMPLATE_LINK = {
  transfer: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/腾讯广告平台子客广告主转移同意函.docx',
  bid: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/腾讯广告服务商合作意向书.docx',
  bid_bp: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/招标服务商商业计划书大纲.pptx',
  advertising_plan: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/招标服务商商业计划书大纲.pptx',
  batch_add_employee_v3: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/批量新增员工信息下载模板v3.xlsx',
  batch_add_employee_v2: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/批量新增员工信息下载模板v2.xlsx',
  batch_edit_employee_v3: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/批量修改员工信息下载模板v3.xlsx',
  batch_edit_employee_v2: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/批量修改员工信息下载模板v2.xlsx',
  batch_upload_personal_info: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/个人简介批量上传模板.csv',
  custom_mark_template: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/服务商子客支付类型标记.xlsx',
  batch_upload_lead: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/1229线索管理上传模板.xlsx',
  batch_upload_channel: 'https://agency-static-1258344696.file.myqcloud.com/fe/template/批量渠道订单上传模板v5.xlsx',
  business_licence: 'https://agency-static-1258344696.cos.ap-guangzhou.myqcloud.com/fe/template/营业执照.png',
  bank_account_license: 'https://agency-static-1258344696.cos.ap-guangzhou.myqcloud.com/fe/template/基本存款账户信息和开户证明.png',
  guarantee_letter: 'https://agency-static-1258344696.cos.ap-guangzhou.myqcloud.com/fe/template/担保函v2025.docx',
  anti_commercial_letter: 'https://agency-static-1258344696.cos.ap-guangzhou.myqcloud.com/fe/template/关于反商业贿赂行为的声明.doc',
  confidentiality_letter: 'https://agency-static-1258344696.cos.ap-guangzhou.myqcloud.com/fe/template/商业合作保密声明函.doc',
};
